export default "__VITE_ASSET__CdAQC45x__"